import type { CartItemType } from "../redux/slice/useCartSlice";

const CART_KEY_PREFIX = "easymarket_catalog_cart_";

export function getCatalogCartStorageKey(shopSlug: string): string {
  return `${CART_KEY_PREFIX}${shopSlug}`;
}

export function saveCatalogCart(shopSlug: string, items: CartItemType[]): void {
  if (!shopSlug) return;
  try {
    sessionStorage.setItem(
      getCatalogCartStorageKey(shopSlug),
      JSON.stringify(items),
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadCatalogCart(shopSlug: string): CartItemType[] {
  if (!shopSlug) return [];
  try {
    const raw = sessionStorage.getItem(getCatalogCartStorageKey(shopSlug));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function clearCatalogCart(shopSlug: string): void {
  if (!shopSlug) return;
  try {
    sessionStorage.removeItem(getCatalogCartStorageKey(shopSlug));
  } catch {
    /* ignore */
  }
}
